import * as React from 'react'

import * as screenerUtils from '../../utils'

const ETFIndustries = ['exchangetradedfund', 'closedendfunddebt', 'closedendfundequity', 'closedendfundforeign']
const ETFFilters = [
  'etf_category',
  'etf_assettype',
  'etf_etftype',
  'etf_sectortheme',
  'etf_region',
  'etf_bondtype',
  'etf_bondmaturity',
  'etf_quanttype',
  'etf_commoditytype',
  'etf_esgtype',
  'etf_dividendtype',
  'etf_structuretype',
  'etf_active',
  'etf_inverse',
  'etf_growthvalue',
  'etf_mktcap',
  'etf_developed',
  'etf_currency',
  'etf_indexweight',
  'etf_sponsor',
  'etf_netexpense',
  'etf_fundflows',
  'etf_return',
  'etf_nav',
  'etf_tags',
  'etf_heldby',
]
export function useShowETF() {
  const query = new URLSearchParams(window.location.search)
  const screenerFilters = screenerUtils.parseScreenerFilters()
  const hasTickerFilters = !!query.get(screenerUtils.ScreenerQuery.Tickers)?.length
  const isShowETFParam = query.get('show_etf') === 'true'
  const sectorFilter = screenerFilters[screenerUtils.ScreenerFilter.Sector]
  const industryFilter = screenerFilters[screenerUtils.ScreenerFilter.Industry]
  const isFinancialSector = sectorFilter?.includes('financial')
  const isEtfIndustry = industryFilter?.some((industry) => ETFIndustries.includes(industry))
  const isEtfFilter = Object.keys(screenerFilters).some((key) => ETFFilters.includes(key))

  const onChange = React.useRef((ev: React.ChangeEvent<HTMLInputElement>) => {
    if (ev.currentTarget.checked) {
      query.set('show_etf', 'true')
    } else {
      query.delete('show_etf')
    }
    window.location.href = `${window.location.pathname}?${query}`
  }).current

  return {
    // The checkbox should only be visible if we’re displaying financial sector and don’t have industry or any etf filter
    visible: (!sectorFilter || isFinancialSector) && !industryFilter && !hasTickerFilters && !isEtfFilter,
    checked: isShowETFParam || hasTickerFilters || isEtfIndustry || isEtfFilter,
    onChange,
  }
}
